import React from 'react';
import { Button, Stack, Typography, useMediaQuery } from '@mui/material';
import { useUserRolePermissions } from 'hooks';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });
  const navigate = useNavigate();
  const title = lgUp ? 'Customer Authorization Overview' : 'Overview';
  const { isProductLoadingManage, isSupplier } = useUserRolePermissions();

  return (
    <Stack
      direction="row"
      sx={{
        backgroundColor: 'surface.light',
        justifyContent: 'space-between',
        mx: -2,
        pb: 2,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        position: { xs: 'initial', lg: 'sticky' },
        pt: 3,
        px: 2,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        top: { xs: 0, lg: 48 },
        zIndex: 1,
      }}
    >
      <Typography data-testid="title" variant="h5">
        {title}
      </Typography>
      {lgUp && isProductLoadingManage && isSupplier && (
        <Button onClick={() => navigate('./create/customer-information')}>New Authorization</Button>
      )}
    </Stack>
  );
};

export default Header;
